// Sprint CAL-1b — voce della To do List: nuova o aperta (modifica, Segna fatto, Rimanda, Riapri, Elimina, Storico)
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useConfirm } from "@/components/ConfirmProvider";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { errore, fmtDataOra, Spiegabile, CampoNota } from "@/pages/crm/crmComuni";
import { perInput, scelteNuovo } from "./calendarioComuni";
import { ChiudiAttivita, Rimanda } from "./ChiusuraAttivita";
import { StoricoAttivita } from "./StoricoAttivita";
import { useGuardiaFinestra } from "./GuardiaFinestra";

const SEL = "h-9 w-full rounded-md border border-input bg-transparent px-2 text-sm disabled:opacity-60";

function iniziale(ev, mie, sedi) {
  if (!ev) return { titolo: "", descrizione: "", giorno: "", ora: "", origine: "mie", azienda: mie[0]?.company_id || "",
    sede: sedi[0] ? `${sedi[0].site_id}:${sedi[0].company_id}` : "", assegnato: "" };
  const t = perInput(ev.inizio);
  return { titolo: ev.titolo || "", descrizione: ev.descrizione || "", giorno: t.slice(0, 10), ora: ev.tutto_il_giorno ? "" : t.slice(11, 16),
    origine: ev.calendario === "sede" ? "sede" : "mie", azienda: ev.company_id, sede: ev.site_id ? `${ev.site_id}:${ev.company_id}` : "",
    assegnato: ev.calendario === "sede" ? ev.proprietario_id || "" : "" };
}

function useAssegnabili(sede, attivo) {
  const [utenti, setUtenti] = useState([]);
  useEffect(() => {
    if (!attivo || !sede) { setUtenti([]); return; }
    const [sid, cid] = sede.split(":");
    api.get(`/calendario/assegnabili?company_id=${cid}&site_id=${sid}`).then((r) => setUtenti(r.data || [])).catch(() => setUtenti([]));
  }, [sede, attivo]);
  return utenti;
}

function CampiTodo({ f, set, mie, sedi, utenti, leggi }) {
  return (
    <div className="space-y-3">
      <div><Label>Titolo *</Label><Input value={f.titolo} disabled={leggi} onChange={(e) => set({ titolo: e.target.value })} data-testid="cal-todo-titolo" /></div>
      <div><Label>Descrizione</Label>{leggi ? <div className="whitespace-pre-wrap text-sm rounded-md border px-3 py-2 bg-slate-50" data-testid="cal-todo-descrizione-testo">{f.descrizione || "—"}</div>
        : <CampoNota value={f.descrizione} onChange={(v) => set({ descrizione: v })} testid="cal-todo-descrizione" />}</div>
      <div className="grid grid-cols-2 gap-2">
        <div><Label>Scadenza</Label><Input type="date" value={f.giorno} disabled={leggi} onChange={(e) => set({ giorno: e.target.value })} data-testid="cal-todo-giorno" /></div>
        <div><Label>Ora (facoltativa)</Label><Input type="time" value={f.ora} disabled={leggi || !f.giorno} onChange={(e) => set({ ora: e.target.value })} data-testid="cal-todo-ora" /></div>
      </div>
      <div className="flex gap-2 items-center">
        <Label className="mr-1">Origine</Label>
        {[["mie", "Mie"], ["sede", "Sede"]].map(([k, l]) => (
          <button key={k} type="button" disabled={leggi || (k === "sede" && !sedi.length)} onClick={() => set({ origine: k })} aria-pressed={f.origine === k}
            className={`rounded-full border px-3 py-0.5 text-xs transition-colors disabled:opacity-50 ${f.origine === k ? "bg-[#0F4C81] text-white border-[#0F4C81]" : "bg-white text-slate-700"}`}
            data-testid={`cal-todo-origine-${k}`}>{l}</button>))}
      </div>
      {f.origine === "mie" && mie.length > 1 && <div><Label>Azienda</Label>
        <select className={SEL} value={f.azienda} disabled={leggi} onChange={(e) => set({ azienda: e.target.value })} data-testid="cal-todo-azienda">
          {mie.map((m) => <option key={m.company_id} value={m.company_id}>{m.azienda_nome}</option>)}</select></div>}
      {f.origine === "sede" && <div className="grid grid-cols-2 gap-2">
        <div><Label>Sede</Label><select className={SEL} value={f.sede} disabled={leggi} onChange={(e) => set({ sede: e.target.value, assegnato: "" })} data-testid="cal-todo-sede">
          {sedi.map((s) => <option key={`${s.site_id}:${s.company_id}`} value={`${s.site_id}:${s.company_id}`}>{`${s.azienda_nome} · ${s.nome}`}</option>)}</select></div>
        <div><Label>Assegnata a</Label><select className={SEL} value={f.assegnato} disabled={leggi} onChange={(e) => set({ assegnato: e.target.value })} data-testid="cal-todo-assegnato">
          <option value="">Nessuno</option>{utenti.map((u) => <option key={u.id} value={u.id}>{u.nome}</option>)}</select></div>
      </div>}
    </div>
  );
}

function corpo(f) {
  const [sid, cid] = (f.sede || ":").split(":");
  const sede = f.origine === "sede";
  return { calendario: sede ? "sede" : "personale", company_id: sede ? cid : f.azienda, site_id: sede ? sid : null, tipo: "todo",
    titolo: f.titolo.trim(), descrizione: f.descrizione, inizio: f.giorno ? `${f.giorno}T${f.ora || "00:00"}` : null, tutto_il_giorno: !f.ora,
    ...(sede ? { proprietario_id: f.assegnato || null } : {}) };
}

export const MSG_MODIFICA = "La modifica chi l'ha creata o chi ha «Calendario: gestisci eventi di sede altrui»";
export const MSG_CHIUDE = "La chiude chi l'ha ricevuta, chi l'ha creata o chi ha «Calendario: gestisci eventi di sede altrui»";

function Comandi({ ev, onFatto, chiudi }) {
  const confirm = useConfirm();
  const azione = async (fn, msg) => { try { await fn(); toast.success(msg); onFatto(); } catch (e) { toast.error(errore(e)); } };
  const elimina = async () => {
    if (await confirm({ title: "Elimina voce", message: `Eliminare «${ev.titolo}»?`, confirmLabel: "SI, elimina" })) {
      azione(() => api.delete(`/calendario/eventi/${ev.id}`), "Voce eliminata");
    }
  };
  // Sprint CAL-1c — comandi non permessi disattivati, con la spiegazione anche al tocco
  const no = (motivo, testid, testo) => <Spiegabile motivo={motivo} testid={`${testid}-spiega`}>
    <Button size="sm" variant="outline" disabled data-testid={testid}>{testo}</Button></Spiegabile>;
  return (
    <div className="flex flex-wrap gap-2">
      {ev.fatto ? (ev.puo_modificare ? <Button size="sm" variant="outline" onClick={() => azione(() => api.post(`/calendario/eventi/${ev.id}/riapri`), "Voce riaperta")}
        data-testid="cal-todo-riapri">Riapri</Button> : no(MSG_MODIFICA, "cal-todo-riapri", "Riapri"))
        : ev.puo_chiudere ? <><Button size="sm" onClick={chiudi} data-testid="cal-todo-dialog-fatto">Segna fatto</Button><Rimanda ev={ev} onFatto={onFatto} testid="cal-todo-dialog-rimanda" /></>
          : <>{no(MSG_CHIUDE, "cal-todo-dialog-fatto", "Segna fatto")}{ev.inizio && no(MSG_CHIUDE, "cal-todo-dialog-rimanda-apri", "Rimanda")}</>}
      <Spiegabile motivo={ev.puo_eliminare ? null : "Serve «Calendario: elimina To do List»"} testid="cal-todo-elimina-spiega">
        <Button size="sm" variant="outline" className="text-rose-700" disabled={!ev.puo_eliminare} onClick={elimina} data-testid="cal-todo-elimina">Elimina</Button></Spiegabile>
    </div>
  );
}

export function TodoDialog({ ev, cal, user, onChiudi, onFatto }) {
  const aziende = Object.fromEntries(cal.sedi.map((s) => [s.company_id, s.azienda_nome]));
  const mie = scelteNuovo(cal, user).filter((c) => c.chiave.startsWith("mio:")).map((c) => ({ company_id: c.company_id, azienda_nome: aziende[c.company_id] || c.etichetta }));
  const [base] = useState(() => iniziale(ev, mie, cal.sedi));
  const [f, setF] = useState(base);
  const [chiudi, setChiudi] = useState(false);
  const leggi = !!ev && !ev.puo_modificare;
  const utenti = useAssegnabili(f.sede, f.origine === "sede");
  const set = (x) => setF((p) => ({ ...p, ...x }));
  const salva = async () => {
    try {
      const b = corpo(f);
      if (f.origine === "mie" && ev?.calendario === "sede") b.proprietario_id = user?.id;  // da Sede a Mie: diventa di chi la sposta
      if (ev) await api.put(`/calendario/eventi/${ev.id}`, { ...b, originali: { titolo: ev.titolo, descrizione: ev.descrizione,
        inizio: ev.inizio ? perInput(ev.inizio) : null, tutto_il_giorno: !!ev.tutto_il_giorno } });
      else await api.post("/calendario/eventi", b);
      toast.success(ev ? "Voce modificata" : "Voce creata"); onFatto(); return true;
    } catch (e) { toast.error(errore(e)); return false; }
  };
  const { radice, chiudi: esci, finestra } = useGuardiaFinestra({ sporco: !leggi && JSON.stringify(f) !== JSON.stringify(base), salva, onChiudi });
  return (
    <Dialog open onOpenChange={(o) => { if (!o) esci(); }}>
      <DialogContent ref={radice} className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="cal-todo-dialog">
        <DialogHeader><DialogTitle>{ev ? "Voce della To do List" : "Nuova voce della To do List"}</DialogTitle></DialogHeader>
        <CampiTodo f={f} set={set} mie={mie} sedi={cal.sedi} utenti={utenti} leggi={leggi} />
        {ev?.opportunita_id && <Link className="text-blue-600 text-sm font-medium hover:underline" to={`/crm/opportunita/${ev.opportunita_id}`}
          data-testid="cal-todo-opportunita">Lead: {ev.opportunita_descrizione || "apri"}</Link>}
        {ev?.fatto && <div className="text-sm text-emerald-700" data-testid="cal-todo-chiusa">Fatta · {ev.esito}
          <span className="block text-xs text-slate-500">Chiusa{ev.fatto_da_nome ? ` da ${ev.fatto_da_nome}` : ""}{ev.fatto_il ? ` il ${fmtDataOra(ev.fatto_il)}` : ""}</span></div>}
        {ev && <Comandi ev={ev} onFatto={onFatto} chiudi={() => setChiudi(true)} />}
        {ev && <StoricoAttivita id={ev.id} />}
        {chiudi && <ChiudiAttivita ev={ev} onChiudi={() => setChiudi(false)} onFatto={() => { setChiudi(false); onFatto(); }} />}
        <DialogFooter>
          <Button variant="outline" onClick={esci} data-testid="cal-todo-annulla">{leggi ? "Chiudi" : "Annulla"}</Button>
          {leggi ? <Spiegabile motivo={MSG_MODIFICA} testid="cal-todo-salva-spiega"><Button disabled data-testid="cal-todo-salva">Salva</Button></Spiegabile>
            : <Button onClick={salva} disabled={!f.titolo.trim() || (f.origine === "sede" ? !f.sede : !f.azienda)} className="bg-[#0F4C81] hover:bg-[#0c3d68]"
            data-testid="cal-todo-salva">Salva</Button>}
        </DialogFooter>
        {finestra}
      </DialogContent>
    </Dialog>
  );
}
